export const unitFaq = {
  head: {
    title: "Fragen & Antworten zur Einheit",
    chip: "KI",
    subPre: "Antworten speziell für",
    subStrong: "diese Einheit",
    subPost: ". Der Agent nutzt sie zuerst, wenn er einem Gast hilft, der hier wohnt (z. B. Türcode, Besonderheiten dieser Wohnung…). Hängen Sie Bilder oder Videos an und der Agent sendet sie, sobald der Gast sie braucht.",
  },
  clone: {
    titleNoun: "FAQs",
    itemNoun: "die FAQs",
    buttonLabel: "Fragen klonen",
  },

  copyOne: {
    title: "Diese Frage kopieren",
    itemNoun: "Frage",
  },
  loading: "Wird geladen…",
  emptyList: "Noch keine Fragen. Legen Sie die erste an, damit der Agent sie beantworten kann.",
  list: {
    newQuestion: "Neue Frage",
    attachments: "{count} Anhang | {count} Anhänge",
    learnedTitle: "Durch Selbstlernen hinzugefügt",
    deleteTitle: "Löschen",
    copyTitle: "In andere Einheiten kopieren",
  },
  form: {
    questionLabel: "Frage",
    answerLabel: "Antwort des Agenten",
    qPlaceholder: "Frage · z. B. Wie lautet der Türcode?",
    aPlaceholder: "Antwort · z. B. Der Eingangscode Ihres Gebäudes lautet 4512.",
    removeAttachment: "Anhang entfernen",
    uploading: "Wird hochgeladen…",
    attach: "Anhängen",
    addQuestion: "Frage hinzufügen",
  },
  preview: {
    tag: "Vorschau · WhatsApp",
    online: "online",
    aiReception: "KI-Rezeption",
    questionPlaceholder: "Frage des Gastes eingeben…",
    answerPlaceholder: "Antwort des Agenten eingeben…",
    videoFile: "Video",
    genericFile: "Datei",
    empty: "Wählen oder erstellen Sie eine Frage, um zu sehen, wie der Agent antwortet.",
    hint: "So sieht es der Gast in seinem Chat",
  },
  footer: {
    saved: "Gespeichert",
    save: "Änderungen speichern",
  },
  errors: {
    load: "Die Fragen konnten nicht geladen werden.",
    attachNeedsQA: "Schreiben Sie Frage und Antwort, bevor Sie Dateien anhängen.",
    attachNeedsSave: "Speichern Sie zuerst, um Dateien anhängen zu können.",
    upload: "Die Datei konnte nicht hochgeladen werden.",
    deleteFile: "Die Datei konnte nicht gelöscht werden.",
    save: "Speichern nicht möglich.",
  },
};
